import React from 'react';
import './style.css';

export default function Loading() {
  return (
    <div className='loading-icon'></div>
  )
}
